import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import { arrayToTree } from 'utils/tree';
import { adjustItemRankAfterInsertion } from './addItemAndRecalculateRanksInSection';

/**
 * Returns an object whose keys are the passed in `selectedItemIds`
 * and whose values are the rank of their corresponding items,
 * across section boundaries and ignoring any non-selected items.
 */

function getAbsoluteRankByItemId(content, selectedItemIds) {
  var selectedItemsInOrder = [];
  function getItemsInOrder(items) {
    items.forEach(function (item) {
      if (selectedItemIds.includes(item.id)) {
        selectedItemsInOrder.push(item);
      }
      if (item.children.length > 0) {
        getItemsInOrder(item.children);
      }
    });
  }
  getItemsInOrder(arrayToTree(content));
  var absoluteRanksById = {};
  selectedItemsInOrder.forEach(function (item, index) {
    absoluteRanksById[item.id] = index;
  });
  return absoluteRanksById;
}

/**
 * Re-assigns parent ids and updates ranks to move an item to
 * a new position in the playlist
 */

export function moveItemsAndReturnNewState(_ref) {
  var content = _ref.content,
    itemIdsToMove = _ref.itemIdsToMove,
    targetParentId = _ref.targetParentId,
    targetRankInSection = _ref.targetRankInSection;
  var absoluteRankByItemId = getAbsoluteRankByItemId(content, itemIdsToMove);
  return content.map(function (item) {
    if (itemIdsToMove.includes(item.id)) {
      return _objectSpread(_objectSpread({}, item), {}, {
        parent_id: targetParentId,
        rankInSection: targetRankInSection + absoluteRankByItemId[item.id]
      });
    } else {
      return adjustItemRankAfterInsertion({
        item: item,
        targetParentId: targetParentId,
        targetRankInSection: targetRankInSection,
        insertedItemCount: itemIdsToMove.length
      });
    }
  });
}